import "core-js/stable";
import "regenerator-runtime/runtime";

import smoothscroll from 'smoothscroll-polyfill';
smoothscroll.polyfill();

import objectFitImages from 'object-fit-images';
objectFitImages();

import { toggleBodyClass } from './_class/_toggle';
import './_thebase/_text-trim';
import './_thebase/_store-home';
import './_thebase/_gallery-slider';
import './_thebase/_about-slider';
import './_thebase/_pulldown';

document.querySelector('.nav-menu').addEventListener('click', toggleBodyClass('menu-open'));
document.querySelector('.nav-close').addEventListener('click', toggleBodyClass('menu-open'));


// //window
// window.addEventListener('resize', (e) =>{
//   if(640 <= innerWidth){
//     document.body.classList.add('menu-open');
//   }else{
//     document.body.classList.remove('menu-open');
//   }
// });
// window.dispatchEvent(new Event('resize'));
//
// import './_nav/_toggle-sub-menu';
// import './_nav/_totop';
// import './_page/_home';
// import './_page/_gallery-slider';
